import React from 'react';
import Alert from '@amzn/awsui-components-console/alert';
import Box from '@amzn/awsui-components-console/box';
import Button from '@amzn/awsui-components-console/button';
import { BUNDLE_FAILURE_STRINGS } from 'src/i18n/bundleFailureStrings';

interface Props {
  readonly onReload?: () => void;
}

/**
 * Shown in place of the app when the resource pack could not be loaded.
 *
 * Its copy is hardcoded at the source locale on purpose — see
 * {@link BUNDLE_FAILURE_STRINGS}.
 *
 * A full reload is the default recovery because the usual cause is a stale CDN
 * edge serving an index that references a pack it no longer has; re-fetching
 * from scratch is what clears it.
 */
const BundleFailureNotice: React.FC<Props> = ({ onReload }) => (
  <Box margin="l" data-testid="bundle-failure-notice">
    <Alert
      type="error"
      header={BUNDLE_FAILURE_STRINGS.header}
      statusIconAriaLabel={BUNDLE_FAILURE_STRINGS.errorIconAria}
      action={
        <Button
          onClick={() => (onReload ? onReload() : window.location.reload())}
        >
          {BUNDLE_FAILURE_STRINGS.reload}
        </Button>
      }
    >
      {BUNDLE_FAILURE_STRINGS.body}
    </Alert>
  </Box>
);

export default BundleFailureNotice;
